import { Link } from 'react-router-dom';

const articleLinks = [
  { label: 'Kompletter Guide', path: '/artikel/oopbuy-spreadsheet-guide' },
  { label: 'Sicherheitsguide', path: '/artikel/oopbuy-sicherheitsguide' },
  { label: 'Versandguide', path: '/artikel/oopbuy-versandguide' },
  { label: 'Anfänger Guide', path: '/artikel/oopbuy-anfaenger-guide' },
  { label: 'Kategorien Übersicht', path: '/artikel/oopbuy-kategorien-uebersicht' },
  { label: 'Preisvergleich', path: '/artikel/oopbuy-preisvergleich' },
  { label: 'Erfahrungen', path: '/artikel/oopbuy-erfahrungen' },
  { label: 'Alternativen', path: '/artikel/oopbuy-alternativen' },
  { label: 'Einkaufstipps', path: '/artikel/oopbuy-einkaufstipps' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/3">
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-900 mb-3 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">O</span>
              OOPBUY Spreadsheet
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              Deine deutsche Informationsplattform rund um das OOPBUY Spreadsheet. Strukturierte Produktlisten, Kategorien und Einkaufsguides für deutsche Käufer.
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-6">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">Navigation</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Startseite</Link>
                <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Shopping Guide</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">SEO Artikel</h4>
              <div className="flex flex-col gap-2">
                {articleLinks.slice(0, 5).map((a) => (
                  <Link key={a.path} to={a.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">{a.label}</Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">Mehr Artikel</h4>
              <div className="flex flex-col gap-2">
                {articleLinks.slice(5).map((a) => (
                  <Link key={a.path} to={a.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">{a.label}</Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} OOPBUY Spreadsheet. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs text-foreground-400">
            Eine unabhängige Informationsplattform – nicht mit OOPBUY verbunden.
          </p>
        </div>
      </div>
    </footer>
  );
}